import React from 'react';
import { METADATA_STORAGE_KEY } from '../../../pages/metadata-search/metadata-search-helpert';
import { useBlastAI, useUserSettings, useZone } from '../../contexts';
import { TSecureDataZone } from '../../contexts/ZoneContext';
import {
    Button,
    Divider,
    Grid,
    Menu,
    MenuItem,
    Typography,
} from '@mui/material';
import { styles } from './data-zone-selector-helper';
import { SdzMenuOption } from './DataZoneMenuOption';
import { Icon } from '@iconify/react';

export const SdzSelector = (): React.JSX.Element => {
    const {
        avaliableSecureDataZones,
        getSelectedDataZone,
        setSelectedDataZone,
    } = useZone();
    const { clearConversation } = useBlastAI();
    const { clearUserSettings } = useUserSettings();

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const selectedEnv = getSelectedDataZone();

    const handleEnvironmentClick = (env: TSecureDataZone): void => {
        setSelectedDataZone(env);
        clearConversation();
        clearUserSettings();

        if (localStorage.getItem(METADATA_STORAGE_KEY)) {
            localStorage.removeItem(METADATA_STORAGE_KEY);
        }
    };

    const handleOpenMenuClick = (
        event: React.MouseEvent<HTMLElement>
    ): void => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (): void => setAnchorEl(null);

    return (
        <>
            <Button onClick={handleOpenMenuClick} sx={styles.sdzSelectorButton}>
                <>
                    <SdzMenuOption env={selectedEnv} isSelectField />
                    <Icon icon='mdi:menu-down' style={styles.sdzSelectorIcon} />
                </>
            </Button>

            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    role: 'listbox',
                }}
                sx={styles.sdzMenu}
            >
                <Grid sx={styles.sdzHeaderContainerStyles}>
                    <Typography sx={styles.sdzHeaderTextStyles}>
                        Secure Data Zones
                    </Typography>
                    <Typography sx={styles.sdzSubHeaderTextStyles}>
                        Choose the environment you would like to view.
                    </Typography>
                </Grid>

                <Divider sx={styles.sdzHeadingDivider} />
                {React.Children.toArray(
                    avaliableSecureDataZones.map((env: TSecureDataZone) => {
                        return (
                            <MenuItem
                                sx={{
                                    ...styles.sdzSelectorMenuItem,
                                    ...styles.sdzMenuItemPadding,
                                }}
                                disabled={selectedEnv?.sdz === env.name.sdz}
                                onClick={(): void =>
                                    handleEnvironmentClick(env)
                                }
                                className='sdz-menuitem'
                            >
                                <SdzMenuOption
                                    env={env?.name}
                                    optionsTextStyles={
                                        styles.sdzMenuOptionStyles
                                    }
                                />
                            </MenuItem>
                        );
                    })
                )}
            </Menu>
        </>
    );
};
